import type { CasinoConfigType } from './types';

export const areRequiredFilled = (obj: Partial<CasinoConfigType>): obj is CasinoConfigType => {
  // List all properties of CasinoConfigType
  const properties: (keyof CasinoConfigType)[] = ['casinoId', 'casinoName'];
  return properties.every((property) => obj[property] !== undefined);
};

export const tablesFormatter = (parsedTables: any): Record<string, string[]> => {
  const tables: Record<string, string[]> = {};
  for (const table in parsedTables) {
    tables[table.toUpperCase()] = parsedTables[table];
  }
  return tables;
};

export const tabsFormatter = (parsedTabs: any): string[] => parsedTabs?.tabs ?? [];

export const booleanFormatter = (value: unknown): boolean =>
  isValidString(value) && validString(value).toLowerCase() === 'true';

export const parseFormatter = (value: unknown): Record<string, string> =>
  isValidString(value) ? JSON.parse(validString(value)) : {};

export const splitFormatter = (value: unknown): string[] => (isValidString(value) ? validString(value).split(',') : []);

export const validString = (value: unknown): string => (value as string).trim();

const _regExWhiteSpace = RegExp(/^\s*$/);
export const isValidString = (value: unknown): boolean =>
  typeof value === 'string' && !!value && _regExWhiteSpace.exec(value) === null;

export const optionalBooleanFormatter = (value: unknown): boolean | undefined => {
  return value === undefined ? undefined : booleanFormatter(value);
};
